import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NavHeaderRoutingModule } from './nav-header-routing.module';
import { NavHeaderComponent } from './nav-header.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbCollapseModule, NgbDropdownModule, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { MenuModelosComponent } from './menu-modelos/menu-modelos.component';
import { MenuServiciosComponent } from './menu-servicios/menu-servicios.component';
import { MenuNovedadesComponent } from './menu-novedades/menu-novedades.component';
import { MenuUsuarioComponent } from './menu-usuario/menu-usuario.component';
import { NavMobileModule } from './nav-mobile/nav-mobile.module';


@NgModule({
  exports:[
    NavHeaderComponent
  ],
  declarations: [
    NavHeaderComponent,
    MenuModelosComponent,
    MenuServiciosComponent,
    MenuNovedadesComponent,
    MenuUsuarioComponent
  ],
  imports: [
    CommonModule,
    NavHeaderRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgbCollapseModule,
    NgbNavModule,
    NgbDropdownModule,
    NavMobileModule
  ]
})
export class NavHeaderModule { }
